import { DataList } from '@brighte/form-components';
import { ModifiedApplicationQuote } from '@graphql/types';
import { getPurchaseDetails, getVendorDetails } from './utils';

export const SingleCategoryDetails = ({ quote }: { quote: ModifiedApplicationQuote }) => {
  const vendorDetails = getVendorDetails(quote);
  const purchaseItemsDetails = getPurchaseDetails(quote);

  return (
    <>
      <DataList title={purchaseItemsDetails?.title} items={purchaseItemsDetails?.items} />
      <DataList title={vendorDetails?.title} items={vendorDetails?.items} />
    </>
  );
};
